var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5295 20.3519C23.9571 20.7599 23.2566 21 22.5 21C20.567 21 19 19.433 19 17.5C19 15.567 20.567 14 22.5 14C23.753 14 24.8522 14.6584 25.4705 15.6481M17 32.0872H19.6103C19.9506 32.0872 20.2889 32.1277 20.6188 32.2086L23.3769 32.8789C23.9753 33.0247 24.5988 33.0388 25.2035 32.9214L28.253 32.3281C29.0585 32.1712 29.7996 31.7854 30.3803 31.2205L32.5379 29.1217C33.154 28.5234 33.154 27.5524 32.5379 26.9531C31.9832 26.4134 31.1047 26.3527 30.4771 26.8103L27.9626 28.6449C27.6025 28.9081 27.1643 29.0498 26.7137 29.0498H24.2855L25.8311 29.0498C26.7022 29.0498 27.4079 28.3633 27.4079 27.5159V27.2091C27.4079 26.5055 26.9156 25.892 26.2141 25.7219L23.8286 25.1417C23.4404 25.0476 23.0428 25 22.6431 25C21.6783 25 19.9319 25.7988 19.9319 25.7988L17 27.0249M31 18.5C31 20.433 29.433 22 27.5 22C25.567 22 24 20.433 24 18.5C24 16.567 25.567 15 27.5 15C29.433 15 31 16.567 31 18.5ZM13 26.6L13 32.4C13 32.9601 13 33.2401 13.109 33.454C13.2049 33.6422 13.3578 33.7951 13.546 33.891C13.7599 34 14.0399 34 14.6 34H15.4C15.9601 34 16.2401 34 16.454 33.891C16.6422 33.7951 16.7951 33.6422 16.891 33.454C17 33.2401 17 32.9601 17 32.4V26.6C17 26.0399 17 25.7599 16.891 25.546C16.7951 25.3578 16.6422 25.2049 16.454 25.109C16.2401 25 15.9601 25 15.4 25L14.6 25C14.0399 25 13.7599 25 13.546 25.109C13.3578 25.2049 13.2049 25.3578 13.109 25.546C13 25.7599 13 26.0399 13 26.6Z",
    stroke: "#3B3B3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaiIcon);
export default __webpack_public_path__ + "static/media/tai-icon.066c833b44f7c785b5416f21421f8433.svg";
export { ForwardRef as ReactComponent };